import React from 'react';
import Landing from './pages/Landing';

export default function App() {
  return <Landing />;
}
